import type { Segmentation, SegmentationChannel } from '@/shared/types/segmentation';

/**
 * Método de disparo da segmentação = filtro base fixo que a legacy-api aplica
 * (segmentationQueryBuilder): contagem, amostra, público salvo e a IA já veem
 * só quem pode receber por aquele canal. Consentimento e descadastro do
 * e-mail/SMS ficam com a campanha, que mostra cada exclusão na contagem.
 */
export const SEGMENTATION_CHANNEL_COPY: Record<SegmentationChannel, { label: string; base: string }> = {
  push: { label: 'Push', base: 'com push disponível' },
  email: { label: 'E-mail', base: 'com e-mail' },
  sms: { label: 'SMS', base: 'com telefone' },
};

/**
 * Na segmentação de push, "tem push" já é a base: o campo some do seletor pra
 * não virar condição redundante (ou que zera o público). Em e-mail/SMS é um
 * recorte válido ("quem não tem o app").
 */
export const PUSH_BASE_FIELD = 'hasPushToken';

/** `?canal=` da URL (link "Criar segmentação" do wizard de e-mail/SMS); o resto vira push. */
export function parseSegmentationChannel(raw: string | null | undefined): SegmentationChannel {
  return raw === 'email' || raw === 'sms' ? raw : 'push';
}

/** Sem `channel` = push (segmentações antigas) ou upload de arquivo. */
export function segmentationChannel(segmentation: Pick<Segmentation, 'channel'>): SegmentationChannel {
  return parseSegmentationChannel(segmentation.channel);
}

/** Upload de arquivo: sem canal e sem critério, a lista serve qualquer envio. */
export function isUploadedAudience(segmentation: Pick<Segmentation, 'channel' | 'criteria'>): boolean {
  return !segmentation.channel && (segmentation.criteria?.groups?.length ?? 0) === 0;
}

/** Campanha de push só usa segmentação de push ou upload (e-mail/SMS têm outra base). */
export function servesPush(segmentation: Pick<Segmentation, 'channel'>): boolean {
  return segmentationChannel(segmentation) === 'push';
}
